import React from "react";

export const teacherArticles = [
  {
    Category: "Key ideas",
    Topic: "How does Swiftgrade Work?",
    Link: "how-does-swiftgrade-work",
    Sublink: "key-idea-topics",
  },
  {
    Category: "Key ideas",
    Topic: "Tutorial video: How to grade assessments in 3 simple steps",
    Link: "grade-in-3-steps",
    Sublink: "key-idea-topics",
  },
  {
    Category: "Key ideas",
    Topic: "Differences between our website and app",
    Link: "differences-between-android",
    Sublink: "key-idea-topics",
  },
  {
    Category: "Key ideas",
    Topic: "Do I need to add my questions into SwiftGrade?",
    Link: "do-i-need-to-upload",
    Sublink: "key-idea-topics",
  },
  {
    Category: "Key ideas",
    Topic: "Do I need to add students to my classes?",
    Link: "do-i-need-to-add",
    Sublink: "key-idea-topics",
  },
  {
    Category: "Key ideas",
    Topic: "How to add students to a class?",
    Link: "how-to-add-students",
    Sublink: "key-idea-topics",
  },
  {
    Category: "Key ideas",
    Topic: "Info video: SwiftGrade features",
    Link: "info-video-swiftgrade-features",
    Sublink: "key-idea-topics",
  },
  {
    Category: "Creating an answer key",
    SubCategory: "General info",
    Topic: "What is an answer key?",
    Link: "what-is-an-answer-key",
    Sublink: "create-answer-key-topics",
  },
  {
    Category: "Creating an answer key",
    SubCategory: "General info",
    Topic: "Walkthrough video: Creating an answer key",
    Link: "walkthrough-answer-key",
    Sublink: "create-answer-key-topics",
  },
  {
    Category: "Creating an answer key",
    SubCategory: "Tips and tricks",
    Topic: "Tips and tricks - Creating an answer key",
    Link: "creating-answer-key-tips",
    Sublink: "create-answer-key-topics",
  },
  {
    Category: "Creating an answer key",
    SubCategory: "Inputting answers",
    Topic: "Adding answers",
    Link: "using-controller-row",
    Sublink: "creating-answer-key-topics",
  },
  {
    Category: "Creating an answer key",
    SubCategory: "Inputting answers",
    Topic: "Keyboard shortcuts",
    Link: "keyboard-shortcuts",
    Sublink: "create-answer-key-topics",
  },
  {
    Category: "Creating an answer key",
    SubCategory: "Inputting answers",
    Topic: "Adding multiple acceptable answers",
    Link: "adding-multiple-acceptable",
    Sublink: "create-answer-key-topics",
  },
  {
    Category: "Creating an answer key",
    SubCategory: "Inputting answers",
    Topic: "Online vs. paper assessments",
    Link: "save-as-online",
    Sublink: "create-answer-key-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "General info",
    Topic: "What are student answer sheets?",
    Link: "what-are-answer-sheets",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "General info",
    Topic: "Can paper answer sheets be printed on regular paper?",
    Link: "can-paper-answer-sheets-be-printed",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "General info",
    Topic:
      "Differences between our multiple choice, written and online answer sheets",
    Link: "differences-multiple-choice",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "General info",
    Topic: "Differences between our pre-filled and no-name answer sheets",
    Link: "pre-input-student-name",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "Paper answer sheets",
    Topic: "Print written answer sheets",
    Link: "print-written-answer",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "Paper answer sheets",
    Topic: "Print multiple choice answer sheets",
    Link: "print-multiple",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "Paper answer sheets",
    Topic: "How to customize our multiple-choice answer sheets",
    Link: "customize-answer-sheets",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "Online answer sheets",
    Topic: "Release online answer sheets to students",
    Link: "release-online-answer",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "Answer sheets",
    SubCategory: "Online answer sheets",
    Topic: "How students respond in online answer sheets",
    Link: "how-students-respond-online",
    Sublink: "answer-sheet-topics",
  },
  {
    Category: "View and send results",
    SubCategory: "General info",
    Topic: "Walkthrough video - The results section",
    Link: "walkthrough-video-results",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Tips and tricks",
    Topic: "Tips and tricks - Results page",
    Link: "results-page-tips",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "General info",
    Topic: "The results tab",
    Link: "the-results-tab",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "General info",
    Topic: "The answers tab",
    Link: "the-answers-tab",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Actions",
    Topic: "Manually change marks",
    Link: "manually-change-marks",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Actions",
    Topic: "Answers flagged as 'Needs Grading'",
    Link: "answers-flagged",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Actions",
    Topic: "Filtering student results",
    Link: "filters-for-answers",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Actions",
    Topic: "Features such as U, SF, Tolerance, AC, etc",
    Link: "features-such-as",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Actions",
    Topic: "View a student’s result info",
    Link: "view-or-edit-results",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Actions",
    Topic: "Send results to students",
    Link: "send-results",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Actions",
    Topic: "Re-marking results",
    Link: "remarking-results",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "General info",
    Topic: "Analysis tab",
    Link: "analysis-tab",
    Sublink: "view-and-send",
  },
  {
    Category: "View and send results",
    SubCategory: "Actions",
    Topic: "How students can take an assessment multiple times",
    Link: "how-students-take-multiple-times",
    Sublink: "view-and-send",
  },
  {
    Category: "Handwriting recognition accuracy",
    SubCategory: "",
    Topic: "Tips to increase handwriting recognition accuracy",
    Link: "tips-increase-accuracy-handwriting",
    Sublink: "handwriting-topics",
  },
  {
    Category: "Handwriting recognition accuracy",
    SubCategory: "",
    Topic: "Tips to increase multiple-choice bubble recognition accuracy",
    Link: "tips-to-increase-multiple",
    Sublink: "handwriting-topics",
  },
  {
    Category: "Handwriting recognition accuracy",
    SubCategory: "",
    Topic: "Tutorial video: How to scan answer sheets for maximum accuracy",
    Link: "maximum-scan-accuracy",
    Sublink: "handwriting-topics",
  },
  {
    Category: "Handwriting recognition accuracy",
    SubCategory: "",
    Topic: "How accurate is Swiftgrade's handwriting recognition?",
    Link: "how-accurate-is-swiftgrade",
    Sublink: "handwriting-topics",
  },
  {
    Category: "Handwriting recognition accuracy",
    SubCategory: "",
    Topic: "What if SwiftGrade incorrectly recognizes student handwriting?",
    Link: "what-if-incorrect",
    Sublink: "handwriting-topics",
  },
  {
    Category: "Our different answer types",
    Topic: "Numeric answers",
    Link: "numeric-answers",
    Sublink: "different-answer-types",
  },
  {
    Category: "Our different answer types",
    Topic: "Fill in the blank answers",
    Link: "fill-in-the-blank-answers",
    Sublink: "different-answer-types",
  },
  {
    Category: "Our different answer types",
    Topic: "Math answers",
    Link: "math-answers",
    Sublink: "different-answer-types",
  },
  {
    Category: "Our different answer types",
    Topic: "Multiple choice answers",
    Link: "multiple-choice-answers",
    Sublink: "different-answer-types",
  },
  {
    Category: "Scanning paper answer sheets",
    Topic: "How to scan paper answer sheets",
    Link: "scan-paper-answer-sheets",
    Sublink: "scanning-paper-answer-sheet-topics",
  },
  {
    Category: "Scanning paper answer sheets",
    Topic: "Tutorial Video - Tips for scanning",
    Link: "tips-for-scanning-tutorial",
    Sublink: "scanning-paper-answer-sheet-topics",
  },
];

export const studentArticles = [
  {
    Category: "Getting started",
    SubCategory: "",
    Topic: "How can I sign up for SwiftGrade?",
    Link: "how-can-i-signup",
    Sublink: "getting-started-topics",
  },
  {
    Category: "Getting started",
    SubCategory: "",
    Topic: "How can I join my teacher's class?",
    Link: "how-can-i-join",
    Sublink: "getting-started-topics",
  },
  {
    Category: "Taking assessments",
    SubCategory: "",
    Topic: "How can I take an online assessment?",
    Link: "how-can-i-take-online",
    Sublink: "taking-assessments-topics",
  },
  {
    Category: "Taking assessments",
    SubCategory: "",
    Topic: "How can I take a paper assessment?",
    Link: "how-can-i-take-paper",
    Sublink: "taking-assessments-topics",
  },
];

function Help() {
  return <></>;
}

export default Help;
